export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  if (className) {
    element.className = className;
  }
  if (text !== undefined) {
    element.textContent = text;
  }
  return element;
}

export function createButton(
  label: string,
  action: () => void,
  className = "terminal-button",
): HTMLButtonElement {
  const button = createElement("button", className, label);
  button.type = "button";
  button.addEventListener("click", action);
  return button;
}
